import { RetailerFooter } from "@faire/retailer-visitor-shared/components/Footer/RetailerFooter";
import { ErrorRow } from "@faire/retailer-visitor-shared/components/SearchProducts/SearchProductsStyles";
import { BlockInheritRow } from "@faire/retailer-visitor-shared/components/SearchProducts/SearchProductsStyles";
import { UserPerceivedLoadTimingContext } from "@faire/web/common/performance/userPerceivedLoadTiming/UserPerceivedLoadTimingContext";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React, { useCallback, useContext } from "react";

export const SearchProductsResultsListFallback = () => {
  const { refCallback } = useContext(UserPerceivedLoadTimingContext);

  const ref = useCallback(
    (element: HTMLDivElement | null) => {
      refCallback?.(element, {
        status: "error",
        error: "failed_to_render_critical_component",
      });
    },
    [refCallback]
  );

  return (
    <div ref={ref} style={{ width: "100%" }}>
      <ErrorRow justify="center">
        <Typography>
          <StrictLocalMsg
            id="bY8DY1"
            defaultMessage="An error has occurred, please try again."
            description={{
              text: "error message on search/discover and explore page when network failed",
            }}
          />
        </Typography>
      </ErrorRow>

      <BlockInheritRow>
        <RetailerFooter />
      </BlockInheritRow>
    </div>
  );
};
